module.exports = __webpack_public_path__ + "img/Photoshop.be6f81d2.png";